
{
  "familyId": "MET-DRIEHOEK-SOORTEN",
  "questions": [
    {
      "id": "MET-DRIEHOEK-SOORTEN-001",
      "familyId": "MET-DRIEHOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "driehoek_soorten",
      "questionType": "multiple_choice",
      "question": "Een driehoek heeft drie zijden van gelijke lengte. Hoe heet deze driehoek?",
      "options": ["Gelijkzijdig", "Gelijkbenig", "Rechthoekig", "Ongelijkzijdig"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Soorten driehoeken",
            "content": "Gelijkzijdig: 3 gelijke zijden, 3 hoeken van 60°. Gelijkbenig: 2 gelijke zijden. Rechthoekig: 1 hoek van 90°. Ongelijkzijdig: alle zijden verschillend.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "driehoek_gelijkzijdig",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Een driehoek met 3 gelijke zijden heet gelijkzijdig. Bij gelijke zijden zijn ook alle hoeken gelijk: 180° ÷ 3 = 60° per hoek.",
        "solutionSteps": [
          "Kijk naar de zijden: alle 3 zijn gelijk",
          "3 gelijke zijden = gelijkzijdig",
          "Alle hoeken zijn dan ook gelijk: 60°"
        ],
        "distractorExplanations": {
          "0": "Goed! Drie gelijke zijden = gelijkzijdig. Alle hoeken zijn dan 60°.",
          "1": "Gelijkbenig heeft slechts 2 gelijke zijden, niet 3. Onthoud: gelijk-benig = 2 gelijke 'benen'.",
          "2": "Rechthoekig gaat over hoeken (één hoek van 90°), niet over gelijke zijden.",
          "3": "Ongelijkzijdig betekent dat alle zijden verschillend zijn. Hier zijn juist alle 3 gelijk."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.triangle-isosceles-vs-equilateral", "label": "Verwart gelijkzijdig met gelijkbenig", "optionIndex": 1 },
          { "id": "met.triangle-confuses-side-with-angle", "label": "Verwart zijden-classificatie met hoeken-classificatie", "optionIndex": 2 },
          { "id": "met.triangle-opposite-classification", "label": "Tegengestelde classificatie gekozen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-DRIEHOEK-SOORTEN-002",
      "familyId": "MET-DRIEHOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "driehoek_soorten",
      "questionType": "multiple_choice",
      "question": "Een driehoek heeft zijden van 5 cm, 5 cm en 8 cm. Welk type driehoek is dit?",
      "options": ["Rechthoekig", "Gelijkzijdig", "Gelijkbenig", "Ongelijkzijdig"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gelijkbenig",
            "content": "Gelijkbenig = precies 2 zijden even lang. De twee gelijke zijden heten 'benen'. De derde zijde heet de 'basis'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "driehoek_gelijkbenig",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Twee zijden zijn gelijk (5 cm en 5 cm), de derde is anders (8 cm). Dat is een gelijkbenige driehoek. De twee gelijke zijden zijn de 'benen'.",
        "solutionSteps": [
          "5 cm = 5 cm (twee gelijke zijden)",
          "8 cm is anders",
          "2 gelijke zijden = gelijkbenig"
        ],
        "distractorExplanations": {
          "0": "Rechthoekig gaat over hoeken (90°), niet over zijden.",
          "1": "Gelijkzijdig zou betekenen dat alle 3 zijden gelijk zijn (5, 5, 5). De derde is hier 8.",
          "2": "Goed! Twee gelijke zijden = gelijkbenig.",
          "3": "Ongelijkzijdig betekent alle zijden verschillend. Hier zijn er twee gelijk."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.triangle-confuses-side-with-angle", "label": "Verwart zijden-info met hoeken", "optionIndex": 0 },
          { "id": "met.triangle-isosceles-vs-equilateral", "label": "Denkt dat 2 gelijke zijden = gelijkzijdig", "optionIndex": 1 },
          { "id": "met.triangle-overlooks-equal-sides", "label": "Ziet de gelijke zijden niet", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-DRIEHOEK-SOORTEN-003",
      "familyId": "MET-DRIEHOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "driehoek_soorten",
      "questionType": "multiple_choice",
      "question": "Een driehoek heeft hoeken van 90°, 45° en 45°. Hoe heet deze driehoek?",
      "options": ["Gelijkzijdig", "Rechthoekig (en gelijkbenig)", "Stomphoekig", "Ongelijkzijdig"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "showWhen": "always",
          "data": {
            "shape": "triangle",
            "base": 4,
            "height": 4,
            "unit": "cm",
            "showGrid": false,
            "showDimensions": false,
            "label": "Welke driehoek is dit?"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rechthoekige driehoek",
            "content": "Een rechthoekige driehoek heeft één hoek van precies 90° (een rechte hoek). De zijde tegenover de rechte hoek heet de 'hypotenusa' — dat is de langste zijde.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "driehoek_rechthoekig",
      "variantIndex": 3,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Er is een hoek van 90° → rechthoekig. De andere twee hoeken zijn gelijk (45° en 45°) → óók gelijkbenig. Het is dus een rechthoekige gelijkbenige driehoek.",
        "solutionSteps": [
          "90° = rechte hoek → rechthoekig",
          "45° = 45° → twee gelijke hoeken → gelijkbenig",
          "Combinatie: rechthoekig én gelijkbenig"
        ],
        "distractorExplanations": {
          "0": "Gelijkzijdig heeft 3 hoeken van 60°, niet 90°-45°-45°.",
          "1": "Goed! 90° maakt het rechthoekig, en de twee gelijke hoeken (45°) maken het ook gelijkbenig.",
          "2": "Stomphoekig heeft een hoek GROTER dan 90°. 90° is precies recht, niet stomp.",
          "3": "Ongelijkzijdig gaat over zijden, niet hoeken. Bovendien zijn twee hoeken gelijk."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.triangle-confuses-angle-with-side", "label": "Verwart hoeken-info met zijden", "optionIndex": 0 },
          { "id": "met.angle-right-vs-obtuse", "label": "Denkt dat 90° een stompe hoek is", "optionIndex": 2 },
          { "id": "met.triangle-confuses-angle-with-side", "label": "Verwart hoeken-info met zijden", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-DRIEHOEK-SOORTEN-004",
      "familyId": "MET-DRIEHOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "driehoek_soorten",
      "questionType": "multiple_choice",
      "question": "Welke driehoek kan NIET bestaan?",
      "options": ["Een driehoek met drie scherpe hoeken", "Een driehoek met één stompe hoek", "Een gelijkbenige rechthoekige driehoek", "Een driehoek met twee rechte hoeken (90° + 90°)"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeksom driehoek",
            "content": "De drie hoeken van een driehoek tellen altijd op tot 180°. Twee rechte hoeken = 90° + 90° = 180°. Dan is er geen ruimte meer voor de derde hoek!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "driehoek_onmogelijk",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De hoeken van een driehoek tellen altijd op tot 180°. Twee rechte hoeken = 90° + 90° = 180°. Dan is er 0° over voor de derde hoek — dat kan niet.",
        "solutionSteps": [
          "Hoeksom driehoek = 180°",
          "90° + 90° = 180° (al vol!)",
          "Derde hoek zou 0° moeten zijn → onmogelijk"
        ],
        "distractorExplanations": {
          "0": "Drie scherpe hoeken kan prima. Bijv. 60° + 60° + 60° = 180° (gelijkzijdig).",
          "1": "Een driehoek met één stompe hoek kan wel. Bijv. 120° + 30° + 30° = 180°.",
          "2": "Een gelijkbenige rechthoekige driehoek bestaat: 90° + 45° + 45° = 180°.",
          "3": "Goed! Twee rechte hoeken = 180°, dan is er geen ruimte voor een derde hoek."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.triangle-angle-sum-unaware", "label": "Past 180°-regel niet toe", "optionIndex": 0 },
          { "id": "met.triangle-angle-sum-unaware", "label": "Past 180°-regel niet toe", "optionIndex": 1 },
          { "id": "met.triangle-impossible-combination", "label": "Denkt dat combinatie onmogelijk is", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "MET-DRIEHOEK-SOORTEN-005",
      "familyId": "MET-DRIEHOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "driehoek_soorten",
      "questionType": "matching",
      "question": "Koppel elk type driehoek aan de juiste eigenschap.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "Gelijkzijdig", "right": "3 gelijke zijden" },
          { "left": "Gelijkbenig", "right": "2 gelijke zijden" },
          { "left": "Rechthoekig", "right": "1 hoek van 90°" },
          { "left": "Stomphoekig", "right": "1 hoek groter dan 90°" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Driehoeksoorten",
            "content": "Gelijkzijdig: 3 gelijke zijden. Gelijkbenig: 2 gelijke zijden. Rechthoekig: 1 hoek van 90°. Stomphoekig: 1 hoek > 90°.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "driehoek_soorten_match",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Gelijkzijdig = 3 gelijke zijden. Gelijkbenig = 2 gelijke zijden. Rechthoekig = 1 hoek van 90°. Stomphoekig = 1 hoek groter dan 90°. Tip: de naam zegt vaak al wat het is.",
        "solutionSteps": [
          "Gelijkzijdig → 3 gelijke zijden",
          "Gelijkbenig → 2 gelijke zijden (de 'benen')",
          "Rechthoekig → 1 hoek van 90°",
          "Stomphoekig → 1 hoek groter dan 90°"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "hasStructuredData": true
      }
    }
  ]
}
